/** CoStar.Api.MarketAnalytics.SearchMarkets.MapOverlayData.GeographyShapeLevel */
export var GeographyShapeLevel;
(function (GeographyShapeLevel) {
    GeographyShapeLevel[GeographyShapeLevel["Submarkets"] = 1] = "Submarkets";
    GeographyShapeLevel[GeographyShapeLevel["StandardGeographies"] = 2] = "StandardGeographies";
})(GeographyShapeLevel || (GeographyShapeLevel = {}));
/** CoStar.Api.MarketAnalytics.SearchMarkets.MapOverlayData.RequestType */
export var RequestType;
(function (RequestType) {
    RequestType[RequestType["Choropleth"] = 1] = "Choropleth";
    RequestType[RequestType["HeatMap"] = 2] = "HeatMap";
})(RequestType || (RequestType = {}));
